export default __webpack_public_path__ + "static/media/qa.7c556a6d.png";